const typeUrlPatterns = {
  "tpsl-signals": "app.stocks.signal",
  "stock-analysis": "app.stocks.stockAnalysis",
  "stock-analysis-filtered": "app.stocks.stockAnalysisFiltered",
  "long-term-signals": "app.stocks.longTermSignal",
  "insider-stock-analysis": "app.stocks.insiderAnalysis",
  "insider-stock-analysis-filtered": "app.stocks.insiderAnalysisFiltered"
};

export default typeUrlPatterns;
